/**
 * StrategyHomePage
 * Main landing page for Strategy Studio app
 */

import React from "react";

import { FundProjectionScreenOutlined } from "@ant-design/icons";
import { Typography } from "antd";

const { Title, Text } = Typography;

export const StrategyHomePage: React.FC = () => {
  return (
    <div style={{ padding: "32px" }}>
      <div style={{ marginBottom: "24px" }}>
        <span
          style={{
            fontFamily: "IBM Plex Mono, monospace",
            fontSize: "12px",
            fontWeight: 500,
            textTransform: "uppercase",
            letterSpacing: "0.1em",
            color: "#BB8800",
          }}
        >
          STRATEGY STUDIO
        </span>
      </div>
      <Title
        level={2}
        style={{
          color: "#e0e0e0",
          fontFamily: "Syne, sans-serif",
          marginBottom: "8px",
        }}
      >
        <FundProjectionScreenOutlined
          style={{ marginRight: "12px", color: "#BB8800" }}
        />
        Strategy Dashboard
      </Title>
      <Text style={{ color: "#999", fontSize: "16px" }}>
        Strategic planning and execution workspace
      </Text>
    </div>
  );
};

export default StrategyHomePage;
